export function getCredentiallessUrl(href: string): string | null {
  try {
    const url = new URL(href);
    if (!url.username && !url.password) return null;

    url.username = "";
    url.password = "";

    return url.href;
  } catch {
    return null;
  }
}

export function sanitizeCredentialedBrowserUrl(): void {
  if (typeof window === "undefined") return;

  const sanitizedUrl = getCredentiallessUrl(window.location.href);
  if (!sanitizedUrl || sanitizedUrl === window.location.href) return;

  // Next server actions resolve submits against the document base URL, which
  // is not updated by history.replaceState after loading a credentialed URL.
  window.location.replace(sanitizedUrl);
}
